import { STUDY_DETAIL } from "./Actions";
import { api, APIS } from "../config/Config";

export function getStudyDetailAction(id) {
  return async function (dispatch) {
    let res;
    try {
      dispatch({ type: STUDY_DETAIL.LOADING });
      res = await api(`${APIS.common}/${id}`);

      const { success, data } = res.data;

      if (success === "true") {
        dispatch({ type: STUDY_DETAIL.SUCCESS, payload: data.data });
      } else {
        dispatch({ type: STUDY_DETAIL.ERROR });
      }
    } catch ({ message }) {
      dispatch({ type: STUDY_DETAIL.ERROR });
      console.error(message);
      return 0;
    }
  };
}
